
import userApi from "./apis/userApi"
import articleApi from "./apis/articleApi"
import menuApi from"./apis/menuApi"
import companyApi from "./apis/companyApi"

const api = {
  userApi,
  articleApi,
  menuApi,
  companyApi
}

export default api;